"use client";

import Image from "next/image";
import Link from "next/link";
import { useRef } from "react";
import siteConfig from "@/config/siteConfig.json";
import type { GlobalSocial } from "@/lib/global";

type Props = {
  data: {
    navData: {
      id: number;
      name: string;
      path: string;
    }[];
  };
  socials?: GlobalSocial[];
};

const Footer = ({ data, socials }: Props) => {
  const { navData } = data;
  const { footer_info, social } = siteConfig;
  const socialItems = socials?.length ? socials : social;

  return (
    <footer className="bg-background-3 overflow-hidden">
      <div className="inner-container large2">
        <div className="section-spacing-bottom section-spacing-top">
          <div className="w-full flex flex-row flex-wrap items-start md:items-center justify-between gap-y-10 md:gap-8 md:pb-4 lg:border-b lg:border-white/8">
            {/* Logo: Sebelah Kiri */}
            <div className="flex-shrink-0 w-[45%] md:w-auto">
              <Link href="/">
                <Image
                  src={footer_info.logo}
                  width={footer_info.logo_width}
                  height={footer_info.logo_height}
                  alt={footer_info.logo_text}
                  className="h-auto object-contain max-w-full"
                />
              </Link>
            </div>

            {/* Menu: Sebelah Kanan (List) CTA */}
            <nav className="w-[50%] md:w-auto flex justify-end md:order-2">
              <ul className="flex flex-col md:flex-row items-end md:items-center gap-4 md:gap-6">
                {navData.map((item) => (
                  <li key={item.id}>
                    <Link
                      href={item.path}
                      className="text-[12px] md:text-[13px] font-semibold uppercase tracking-widest text-white border-b lg:border-none border-white pb-1 hover:text-white/60 hover:border-white/60 transition-all duration-300"
                    >
                      {item.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </nav>

            {/* Social Media */}
            <div className="w-full md:w-auto flex justify-center md:flex-shrink-0 mt-2 md:mt-0 md:order-3">
              <ul className="flex items-center gap-6">
                {socialItems.map((item) => (
                  <li key={item.name}>
                    <a
                      href={item.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="group flex items-center justify-center transition-transform hover:scale-110 duration-300"
                      aria-label={item.name}
                    >
                      <Image
                        src={`/assets/imgs/icon/socialmedia/${item.name}-icon.svg`}
                        width={24}
                        height={24}
                        alt={item.name}
                        className="h-5 w-5 md:h-[22px] md:w-[22px] object-contain opacity-70 group-hover:opacity-100 transition-opacity duration-300"
                      />
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
